<template>

  <b-container v-if="products.length > 0" class="pb-5">
    <b-row class="justify-content-right pt-5 pr-5">
      <slot name="p-1"></slot>
    </b-row>

    <b-row class="justify-content-center px-1 pb-5 pt-3" v-if="getProducts != null">

      <b-col lg="12" md="9" sm="12" class="py-1 px-0 w-100">
        <swiper v-if="products.length > 0" ref="mySwiper" :options="swiperOptions" class="slider-background">
          <swiper-slide v-for="product in products" :key="product.id" class="p-2">

            <div class="card">
              <div class="sticky-discount" v-if="product.offer > 0">
            <span>
              <span>{{ formatNumber(parseInt(product.offer)) }}</span
              ><span>  تخفیف</span></span>
              </div>


              <router-link :to="{ name: 'Product', params: { name: product.raw_link } }">
                <img
                    class="card-img-top"
                    :alt="product.name"
                    :src="product.thumbnail"
                />
              </router-link>


              <div class="card-body card-body-text">


                <router-link class="text-decoration-none text-dark"
                             :to="{ name: 'Product', params: { name: product.raw_link } }">
                  <span class="font-weight-bold mt-1 d-block custom-font-size">{{ product.name.slice(0, 50) }}</span>
                </router-link>


                <del v-if="product.offer > 0" class="prices d-block">
                  {{
                    formatNumber(parseInt(product.price))
                  }}
                  تومان
                </del>

                <span class="prices">{{
                    formatNumber(parseInt(product.price - product.offer))
                  }}</span
                ><span class="info mr-1">تومان</span>
                <br/>


                <div v-if="product.quantity > 0 || product.quantity == null ">
                  <router-link class="text-decoration-none"
                               :to="{ name: 'Product', params: { name: product.raw_link } }">


                    <b-button v-if="product.is_digital == 1" class="card-button" variant="primary">
                      {{ digitalShoppingCartBadge }}
                      <b-icon icon="cart-fill" class="h2 mr-1 text-white text-bold"/>
                    </b-button>

                    <b-button v-else class="card-button" variant="primary">
                      {{ physicalShoppingCartBadge }}
                      <b-icon icon="cart-fill" class="h2 mr-1 text-white text-bold"/>
                    </b-button>


                    <span v-if="isProductActive(product) ">

                <b-button v-if="IsAuthenticated && product.is_digital == 0 " @click.prevent="basketAddItem(product)"
                          class="card-button mr-2 "
                          variant="primary">
                  <b-icon icon="plus" class="add-shopping-cart-button"/>
                </b-button>

                <b-button v-else-if="!IsAuthenticated && product.is_digital == 0"
                          @click.prevent="addUnAuthItem(product)"
                          class="card-button mr-2 " variant="primary">
                  <b-icon icon="plus" class="add-shopping-cart-button"/>
                </b-button>


              </span>
                    <span class="text-decoration-none d-block p-1 "
                          v-else>زمان برای خرید این محصول به پایان رسیده است.</span>

                  </router-link>

                </div>
                <div v-else>
                  <button class="btn btn-primary rounded-pill col-lg-4">ناموجود</button>
                </div>


              </div>
            </div>


          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>

      </b-col>
    </b-row>

    <b-row>
      <div class="ml-auto mr-auto">
        <m-pagination-400 v-if="havePagination" :meta="paginationMeta" :on-change-page="changePage"/>
      </div>

      <slot name="more"/>
    </b-row>
  </b-container>

</template>

<script>
import {mapGetters} from "vuex";
import router from "@/router";
import {Swiper, SwiperSlide, directive} from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import {formatNumber} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter'
import {isProductActive} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Timing";
import {addUnAuthItem, basketAddItem} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";

export default {
  name: "OfferProducts300",
  props: {
    is_digital: {
      default: ''
    },
    title: {
      default: ''
    },
    firstCategory: {
      default: 'آخرین محصولات',
    },
    digitalShoppingCartBadge: {
      default: 'مشاهده و خرید',
    },
    physicalShoppingCartBadge: {
      default: 'مشاهده و خرید',
    },
    showNumber: {},
    havePagination: {},
  },
  components: {Swiper, SwiperSlide, directive},
  data() {
    return {
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 30,
        autoplay: {
          delay: 2500,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          100: {
            slidesPerView: 1,
          },
          600: {
            slidesPerView: 2,
          },
          998: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          }
        }
      },
    }
  },
  computed: {
    ...mapGetters({
      products: 'Product/getOfferProducts',
      paginationMeta: "Content/getPaginationMeta",
    }),
    getProducts() {
      if (this.showNumber) {
        const products = this.products;
        return products.slice(0, this.showNumber)
      } else {
        return this.products
      }
    },
    IsAuthenticated() {
      return this.$store.getters["User/isAuthenticated"];
    },
  },
  methods: {
    filterBySortOrder(order) {
      this.$store.commit("Product/setFilters", {
        key: "sort",
        value: order,
      });
      router.push({
        name: "Products",
        query: {...router.currentRoute.query, sort: order},
      });
      this.filterAction();
    },
    filterAction() {
      if (
          this.$store.getters["Product/getFilter"]("search").trim().length == 0
      ) {
        this.$store.dispatch("Product/setProducts", 1);
      } else {
        this.$store.dispatch("Product/filteredProducts");
      }
    },
    changePage(page) {
      this.$store.dispatch("Product/setProducts", page);
      router.push({name: "Products", query: {...router.currentRoute.query, page: page}})
    },
    formatNumber,
    isProductActive,
    basketAddItem,
    addUnAuthItem,
  },
  async mounted() {
    await this.$store.dispatch('Product/getOfferProducts')
  }
}
</script>

<style scoped>
.slider-row {
  padding-top: 20px;
  margin-left: 30px;
  margin-right: 30px;
}

.slider-controls {
  border-bottom: 1px solid #c4c4c4;
}

.see-more-link {
  color: var(--primary);
  font-size: 19px;
  font-weight: bold;
}

.card-button {
  border-radius: 15px;
  color: var(--light-info);
  font-size: 10px;
  font-weight: bold;
  margin-top: 10px;
}

.card-button:hover {
  border-color: white;
}

.card-body-text {
  text-align: center;
  direction: rtl;
}

.card-body {
  padding: 0px;
  padding-bottom: 5px;
}

.card {
  min-height: 370px;
  max-height: auto;
  border-radius: 10px;
  margin: 0px;
  margin-right: 10px;
}


.card .card-img-top {
  height: 200px;
  border-radius: 10px;
  object-fit: contain;
}

.prices {
  font-weight: bold;
  font-size: 17px;
}

.info {
  font-size: 11px;
  font-weight: bold;
}

.b-icon {
  padding: 0px;
  margin: 0px;
  font-size: 10px;
  color: var(--primary);
}

.sticky-discount {
  padding: 5px;
  position: fixed;
  margin: 10px;
  font-size: 12px;
  font-weight: bold;
  color: white;
  background-color: var(--secondary);
  border-radius: 14px;
  border-bottom-right-radius: 0px;
  min-width: max-content;
}

.slider-btn > .b-icon {
  color: var(--primary);
  font-weight: bold;
}

.custom-icon-font-size {
  font-size: 20px;
}

.custom-font-size {
  font-size: 13px;
}

.add-shopping-cart-button {
  font-size: 20px !important;
  color: var(--light-white) !important;
}

</style>